// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uNSX","controls":"styles_controls__Jt8uh","charLimit":"styles_charLimit__nRbTq","input":"styles_input__1byof","send":"styles_send__168H8"};